<!-- PROCESO NORMAL -->
<tec-pwcs-layout
    [ngClass]="{
        'pwcs-style-old': operation.config?.iframe,
        'dark': designService.isDarkMode(),
        'hide-subtitle': !(operation?.config.tutorial || pageWarning.show || handsetLandscape || flexibleScreen === 'picker' || flexibleScreen === 'upload'),
        'take-photo': !capturedImage && !operation?.config?.tutorial && !pageWarning.show && !handsetLandscape && (isModeSemiManual || flexibleScreen === 'photo') && eudiScreen === null && midniScreen === null,
        'barcode-mode': barcodeScanActive
    }"
    [title]="pageWarning.type === PAGE_WARNING.HELP ? (helpTitle | translate) : ''"
    [subtitle]="flexibleLayoutSubtitle"
    [footerLabel]="operation?.config.tutorial && !pageWarning.show && permissionsCamera && !handsetLandscape ? ('GENERAL.TUTORIAL_ENCRYPTION' | translate) : ''">
    @if (testMode && !env.production) {
        <tec-topnav [img]="'assets/images/tecalis' + (designService.isDarkMode() ? '-dark' : '') + '.svg'">
            <!-- <tec-switch size="sm" label="Dark mode" [formControl]="darkMode"></tec-switch> -->
            <tec-switch size="sm" label="Rect" [formControl]="formRect" (valueChange)="positionDocumentService.setDraw($event)"></tec-switch>
        </tec-topnav>
    }

    <tec-progress
        [value]="progressService.getValue(ocrConf)"
    ></tec-progress>

    <ng-container content>
        <!-- SIN PERMISOS -->
        @if (!permissionsCamera) {
            <tec-tile
                type="status"
                [title]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_DESCRIPTION' | translate"
                icon="icon-alert">
                <tec-link [label]="'LIFE_CHECK.HELP.TITLE' | translate" (click)="isVisibleHelpNoPermissionsCamera = true;"></tec-link>
            </tec-tile>
        }

        <!-- CON PERMISOS -->
        @if (permissionsCamera) {
            <!-- MAIN -->
            <div class="content__identity" [ngStyle]="{'display': operation?.config.tutorial || pageWarning.show || handsetLandscape || (midniScreen !== null && midniEnabled) || (eudiScreen !== null && eudiEnabled) || barcodeScanActive || flexibleScreen === 'picker' || flexibleScreen === 'upload' ? 'none' : 'contents'}">
                @if (loading.show) {
                    <tec-spinner
                        [show]="loading.show"
                        [opaque]="true"
                        [text]="loading.text"
                        [img]="designService.getCustomSpinnerUrl() || undefined"
                    ></tec-spinner>
                }
                <tec-scan
                    [hidden]="loading.show"
                    [match]="match || detected || check || isGapBetweenTests"
                    [detected]="!animation && detected"
                    [check]="check"
                    [alertText]="centerScanText">
                    @if (animation || lottieAnimationOptions) {
                        <div class="pwcs-lottie-frame">
                            <ng-lottie
                                [options]="lottieAnimationOptions || { path: animation }"
                                (loopComplete)="loopComplete($event)"
                            ></ng-lottie>
                        </div>
                    }
                    <div class="video">
                        @if (midniScreen !== 'desktop') {
                        <app-video
                            [ngClass]="{'video-hidden': showCapturedImage && capturedImage}"
                            [debugMode]="formRect?.value"
                            [animationFrame]="animationFrame"
                            [constraints]="ocrService.constraints"
                            [forceFlipHorizontal]="true"
                            [enableTapToFocus]="!showCapturedImage && !loading.show && !pageWarning.show"
                            [zoomFactor]="ocrPreviewZoomFactor"
                            [zoomOffsetX]="ocrPreviewZoomOffsetX"
                            [zoomOffsetY]="ocrPreviewZoomOffsetY"
                            [zoomTransformOrigin]="ocrPreviewTransformOrigin"
                            (cameraError)="onCameraError($event)"
                            (cameraPermissionRevoked)="onCameraPermissionRevoked()"
                            (cameraStarted)="onCameraStarted($event)"
                            (cameraSwitchStarted)="onCameraSwitchStarted()"
                            (cameraSwitchCompleted)="onCameraSwitchCompleted()"
                        ></app-video>
                        }

                        <!-- Imagen capturada superpuesta (zoom ya incluido en el JPEG; sin transform CSS adicional) -->
                        @if (showCapturedImage && capturedImage) {
                            <img [src]="capturedImage" />
                        }
                    </div>
                </tec-scan>
                @if (!loading.show && (!alertContent?.label || !alertContent?.status)) {
                    <span
                        class="content__identity__subtitle-mobile"
                        [innerHTML]="subtitle"
                    ></span>
                }
                <div class="tec-alert--float">
                    @if (!loading.show && !showCapturedImage && alertContent?.label && alertContent?.status) {
                        <tec-alert
                            hiddenCloseButton
                            type="message"
                            [status]="alertContent.status"
                            [msg]="alertContent.label"
                            [icon]="alertContent.icon"
                        ></tec-alert>
                    }
                </div>
                <!-- BOTON CAMBIO CAMARA -->
                @if (operation?.config?.iframe && allCameras && allCameras.length > 1) {
                    <div class="change-camera">
                        <span>{{ 'GENERAL.BUTTON.CHANGE_CAMERA' | translate }}</span>
                        <tec-button-icon
                            icon="icon-refresh"
                            type="circle"
                            size="lg"
                            (clickEvent)="changeCamera()"
                        ></tec-button-icon>
                    </div>
                }

                <!-- QR -->
                @if (operation?.config?.iframe && !loading.show) {
                    <div [ngClass]="{'widget': true, 'open': openQR}">
                        <div class="widget__intro">
                            <h6>{{ 'GENERAL.QR.TITLE' | translate }}</h6>
                            <span>{{ 'GENERAL.QR.DESCRIPTION' | translate }}</span>
                        </div>
                        <div class="widget__content">
                            <div class="widget__content__qr" id="qrcode2" [title]="auth.getQRUrl()">
                                <tec-qr [url]="auth.getQRUrl()" />
                            </div>
                            <p class="widget__content__url">{{ auth.getQRUrl() }}</p>
                        </div>
                        <button class="button button-icon" (click)="openQR = !openQR">
                            <i class="icon-chevron-down"></i>
                        </button>
                    </div>
                }

                @if (showFlexiblePreferLink && eudiScreen === null) {
                    <tec-link
                        class="midni-prefer-link"
                        [label]="flexiblePreferLinkKey | translate"
                        (click)="onFlexiblePreferClick()"
                    ></tec-link>
                }

                @if (flexibleScreen === 'photo' && !loading.show && !pageWarning.show) {
                    <tec-link
                        class="midni-prefer-link"
                        [label]="'OCR.FLEXIBLE.PREFER_OTHER_METHOD' | translate"
                        (click)="preferOtherMethodFromPhoto()"
                    ></tec-link>
                }
                <!-- ACTIVA: prefer EUDI dedicado. En Flexible EUDI va al picker (NIF-960). -->
                @if (eudiEnabled && !isFlexibleMode && !loading.show && !pageWarning.show && midniScreen === null && eudiScreen === null) {
                    <tec-link
                        class="midni-prefer-link"
                        [label]="'OCR.EUDI.PREFER' | translate"
                        (click)="openEudi()"
                    ></tec-link>
                }


                <!-- Imágenes auxiliares -->
                <div style="display: flex;" style="display: none;">
                    <img id="imageAux1">
                    <img id="imageAux2">
                    <canvas id="canvasAux1"></canvas>
                    <canvas id="canvasAux2"></canvas>
                </div>
            </div>

            <!-- TUTORIAL -->
            @if (operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
                <div class="tutorial-image">
                    @if (operation.type === operationType.OCR) {
                        <pwcs-inline-svg
                            [src]="getDniPhotoSideAsset('assets/images/doc-reverse.svg')"
                            idSuffix="ocr-tutorial-doc"
                        />
                    }
                    <!-- <img *ngIf="operation.type === operationType.OCR_FRONT" [src]="'assets/images/doc-reverse.svg'"> -->
                </div>
                <tec-link (click)="openDocumentHelp()">
                    {{ 'OCR.HELP.TUTORIAL_QUESTION' | translate }}
                </tec-link>
            }

            <!-- HELP -->
            @if (pageWarning.show) {
                @if (pageWarning.type === PAGE_WARNING.HELP) {
                    @if (!isVisibleHelpValidDocuments) {
                    <div class="layout--50-50">
                        <tec-tile
                            type="default"
                            styling="default"
                            [badge]="{ label: '1' }">
                            <h5>{{ 'OCR.BACK.HELP.TITLE_1' | translate }}</h5>
                            @if (isFirstSideScan()) {
                                <span class="f16" [innerHTML]="'OCR.HELP.DESCRIPTION_DOC_FIRST' | translate"></span>
                                <ng-container *ngTemplateOutlet="ocrAllowedDocsCollapseGroup"></ng-container>
                            } @else if (isSecondScanBackSide()) {
                                <span class="f16" [innerHTML]="'OCR.BACK.HELP.DESCRIPTION_DOC_REV_AFTER_FRONT' | translate"></span>
                                <div class="image-group image-group--alone">
                                    <pwcs-inline-svg
                                        [src]="'assets/images/id-back' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                        idSuffix="ocr-help-id-back-after-front"
                                    />
                                </div>
                            } @else if (getDocumentSideId() !== documentCheckId.FRONT) {
                                <span class="f16" [innerHTML]="'OCR.BACK.HELP.DESCRIPTION_DOC_REV' | translate"></span>
                                <ng-container *ngTemplateOutlet="ocrAllowedDocsCollapseGroup"></ng-container>
                            } @else {
                                <span class="f16" [innerHTML]="'OCR.BACK.HELP.DESCRIPTION_DOC_ANV' | translate"></span>
                                <div class="image-group image-group--alone">
                                    <pwcs-inline-svg
                                        [src]="getDniPhotoSideAsset('assets/images/id-front.svg')"
                                        idSuffix="ocr-help-id-front"
                                    />
                                </div>
                            }
                        </tec-tile>
                        <tec-tile
                            type="default"
                            styling="default"
                            [badge]="{ label: '2' }">
                            <h5>{{ 'OCR.BACK.HELP.TITLE_2' | translate }}</h5>
                            <div class="grid grid-e2-sm grid-no-responsive">
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="getDniPhotoSideAsset('assets/images/id-blurred.svg')"
                                        idSuffix="ocr-help-id-blurred"
                                    />
                                    <span>{{ 'OCR.BACK.MODAL_HELP.TIP_1' | translate }}</span>
                                </div>
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="getDniPhotoSideAsset('assets/images/id-bright.svg')"
                                        idSuffix="ocr-help-id-bright"
                                    />
                                    <span>{{ 'OCR.BACK.MODAL_HELP.TIP_2' | translate }}</span>
                                </div>
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="getDniPhotoSideAsset('assets/images/id-cut.svg')"
                                        idSuffix="ocr-help-id-cut"
                                    />
                                    <span>{{ 'OCR.BACK.MODAL_HELP.TIP_3' | translate }}</span>
                                </div>
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="getDniPhotoSideAsset('assets/images/id-finger.svg')"
                                        idSuffix="ocr-help-id-finger"
                                    />
                                    <span>{{ 'OCR.BACK.MODAL_HELP.TIP_6' | translate }}</span>
                                </div>
                            </div>
                        </tec-tile>
                    </div>
                    }
                    @if (isVisibleHelpValidDocuments && isMidniHelpContext) {
                    <div class="layout--50-50" style="width: 100%;">
                        <tec-tile type="default" styling="default" [badge]="{ label: '1' }">
                            <h5>{{ 'OCR.MIDNI.HELP_GENERATE_QR_TITLE' | translate }}</h5>
                            <ol class="midni-help-steps f16">
                                <li [innerHTML]="'OCR.MIDNI.HELP_STEP_1' | translate"></li>
                                <li [innerHTML]="'OCR.MIDNI.HELP_STEP_2' | translate"></li>
                                <li [innerHTML]="'OCR.MIDNI.HELP_STEP_3' | translate"></li>
                            </ol>
                            <p class="midni-help-download f16">{{ 'OCR.MIDNI.HELP_DOWNLOAD_LABEL' | translate }}</p>
                            <div class="grid grid-e2-sm">
                                <tec-button-collapse
                                    [img]="'assets/images/icon-google-play.svg'"
                                    [title]="'OCR.MIDNI.PLAY_STORE' | translate"
                                    [expanded]="false"
                                    (click)="openMiDNIPlayStore()">
                                </tec-button-collapse>
                                <tec-button-collapse
                                    [img]="'assets/images/icon-app-store' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                    [title]="'OCR.MIDNI.APP_STORE' | translate"
                                    [expanded]="false"
                                    (click)="openMiDNIAppStore()">
                                </tec-button-collapse>
                            </div>
                        </tec-tile>
                        <tec-tile type="default" styling="default" [badge]="{ label: '2' }">
                            <h5>{{ 'OCR.BACK.HELP.TITLE_2' | translate }}</h5>
                            <div class="grid grid-e2-sm grid-no-responsive">
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="'assets/images/qr-blurred' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                        idSuffix="ocr-help-qr-blurred"
                                    />
                                    <span>{{ 'OCR.BACK.MODAL_HELP.TIP_1' | translate }}</span>
                                </div>
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="'assets/images/qr-bright' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                        idSuffix="ocr-help-qr-bright"
                                    />
                                    <span>{{ 'OCR.BACK.MODAL_HELP.TIP_2' | translate }}</span>
                                </div>
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="'assets/images/qr-cut' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                        idSuffix="ocr-help-qr-cut"
                                    />
                                    <span>{{ 'OCR.BACK.MODAL_HELP.TIP_3' | translate }}</span>
                                </div>
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="'assets/images/qr-finger' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                        idSuffix="ocr-help-qr-finger"
                                    />
                                    <span>{{ 'OCR.BACK.MODAL_HELP.TIP_6' | translate }}</span>
                                </div>
                            </div>
                        </tec-tile>
                    </div>
                    }
                    @if (isVisibleHelpValidDocuments && !isMidniHelpContext) {
                    <div style="width: 100%; align-items: center;" class="item-group">
                        @if (restrictionErrorMsg) {
                            <tec-alert
                                [msg]="restrictionErrorMsg"
                                type="message"
                                status="error"
                                hiddenCloseButton
                                icon="icon-alert"
                            ></tec-alert>
                        }
                        <tec-tile type="default" styling="default">
                            <h5>{{ 'OCR.BACK.HELP.TITLE_1' | translate }}</h5>
                            <ng-container>
                                @if (isFirstSideScan()) {
                                    <span class="f16" [innerHTML]="'OCR.HELP.DESCRIPTION_DOC_FIRST' | translate"></span>
                                } @else {
                                    <span class="f16" [innerHTML]="'OCR.BACK.HELP.DESCRIPTION_DOC_REV' | translate"></span>
                                }
                                <ng-container *ngTemplateOutlet="ocrAllowedDocsCollapseGroup"></ng-container>
                            </ng-container>
                        </tec-tile>
                    </div>
                    }
                    @if (isVisibleHelpValidDocuments && !isMidniHelpContext) {
                        <tec-alert [msg]="'OCR.BACK.MODAL_HELP.TIP_5' | translate" type="message" hiddenCloseButton icon="icon-info"></tec-alert>
                    }
                }
                @if (pageWarning.type === PAGE_WARNING.VERIFICATION_FAIL) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.SERVER_ERROR) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.CAMERA_ERROR) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.INSUFFICIENT_OCR_READ) {
                    <tec-tile
                        type="status"
                        [title]="'OCR.PAGE_WARNING.INSUFFICIENT_OCR_READ.TITLE' | translate"
                        [subtitle]="'OCR.PAGE_WARNING.INSUFFICIENT_OCR_READ.DESCRIPTION' | translate">
                    </tec-tile>
                    <tec-tile type="default" styling="default">
                        <div class="grid grid-e3-sm grid-no-responsive">
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="getDniPhotoSideAsset('assets/images/id-bright.svg')"
                                    idSuffix="ocr-insufficient-read-id-bright"
                                />
                                <span>{{ 'OCR.PAGE_WARNING.INSUFFICIENT_OCR_READ.TIP_BRIGHT' | translate }}</span>
                            </div>
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="getDniPhotoSideAsset('assets/images/id-cut.svg')"
                                    idSuffix="ocr-insufficient-read-id-cut"
                                />
                                <span>{{ 'OCR.PAGE_WARNING.INSUFFICIENT_OCR_READ.TIP_FRAME' | translate }}</span>
                            </div>
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="getDniPhotoSideAsset('assets/images/id-blurred.svg')"
                                    idSuffix="ocr-insufficient-read-id-blurred"
                                />
                                <span>{{ 'OCR.PAGE_WARNING.INSUFFICIENT_OCR_READ.TIP_LEGIBLE' | translate }}</span>
                            </div>
                        </div>
                    </tec-tile>
                }
                <!-- NIF-921: falta anverso/reverso en upload Flexible -->
                @if (pageWarning.type === PAGE_WARNING.FLEXIBLE_UPLOAD_MISSING_SIDE) {
                    <tec-tile
                        type="status"
                        [title]="flexibleUploadMissingSideTitleKey | translate"
                        [subtitle]="flexibleUploadMissingSideDescriptionKey | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.INCORRECT_DOCUMENT_SIDE) {
                    <tec-tile
                        type="status"
                        [title]="'OCR.PAGE_WARNING.INCORRECT_DOCUMENT_SIDE.TITLE' | translate"
                        [subtitle]="'OCR.PAGE_WARNING.INCORRECT_DOCUMENT_SIDE.DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.DIFFERENT_DOCUMENTS) {
                    <tec-tile
                        type="status"
                        [title]="'OCR.PAGE_WARNING.DIFFERENT_DOCUMENTS.TITLE' | translate"
                        [subtitle]="'OCR.PAGE_WARNING.DIFFERENT_DOCUMENTS.DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.BOTH_SIDES_IN_ONE_IMAGE) {
                    <tec-tile
                        type="status"
                        [title]="'OCR.FLEXIBLE.UPLOAD_BOTH_SIDES_IN_ONE_TITLE' | translate"
                        [subtitle]="'OCR.FLEXIBLE.UPLOAD_BOTH_SIDES_IN_ONE_DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.MISSING_ADDRESS) {
                    <tec-tile
                        type="status"
                        [title]="'OCR.PAGE_WARNING.MISSING_ADDRESS.TITLE' | translate"
                        [subtitle]="'OCR.PAGE_WARNING.MISSING_ADDRESS.DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
            }

            <!-- HANDSETLANDSCAPE -->
            @if (handsetLandscape && !pageWarning.show) {
                <app-handset-landscape-tile />
            }

            <!-- BARCODE: lectura PDF417 en reverso DNI_COL -->
            @if (barcodeScanActive && !handsetLandscape && !pageWarning.show) {
                <div class="barcode-screen">
                    @if (loading.show) {
                        <tec-spinner
                            [show]="loading.show"
                            [opaque]="true"
                            [text]="loading.text"
                            [img]="designService.getCustomSpinnerUrl() || undefined"
                        ></tec-spinner>
                    }
                    <app-barcode-scan
                        #barcodeScanner
                        [constraints]="ocrService.barcodeConstraints"
                        [documentDetector]="documentDetector"
                        instructionI18nKey=""
                        (imageCaptured)="onBarcodeImageCaptured($event)"
                        (cameraPermissionRevoked)="onCameraPermissionRevoked()"
                    />
                </div>
            }

            <!-- NIF-802 Flexible: selector de método -->
            @if (flexibleScreen === 'picker' && !handsetLandscape && !pageWarning.show) {
                <div class="flexible-screen flexible-screen--picker">
                    <div
                        class="flexible-screen__methods"
                        [style.--picker-cols]="flexiblePickerCols"
                    >
                        @for (method of flexiblePickerMethods; track method; let i = $index) {
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [title]="flexibleMethodTitleKey(method) | translate"
                                [description]="flexibleMethodDescriptionKey(method) | translate"
                                [tagImage]="flexibleMethodTagImage(method, i)"
                                (click)="selectFlexibleMethod(method)"
                            ></tec-card-access>
                        }
                    </div>
                </div>
            }

            <!-- NIF-802 Flexible: adjuntar archivos (layout tipo DOCUMENTS) -->
            @if (flexibleScreen === 'upload' && !handsetLandscape && !pageWarning.show) {
                <div class="flexible-screen flexible-screen--upload">
                    @if (loading.show) {
                        <tec-spinner
                            [show]="loading.show"
                            [opaque]="true"
                            [text]="loading.text"
                            [img]="designService.getCustomSpinnerUrl() || undefined"
                        ></tec-spinner>
                    }
                    <tec-tile
                        type="default"
                        icon="icon-file"
                        class="one-doc"
                        style="width: 100%"
                    >
                        <h5>{{ flexibleUploadTitleKey | translate }}</h5>
                        <ng-container actions>
                            <tec-link
                                [label]="'DOCUMENTS.INSTRUCTIONS' | translate"
                                (click)="openFlexibleUploadInstructions()"
                            />
                        </ng-container>

                        @if (!flexibleUploadBothSidesAlertDismissed) {
                            <tec-alert
                                class="flexible-upload-alert"
                                [msg]="flexibleUploadAlertKey | translate"
                                type="message"
                                status="default"
                                icon="icon-alert"
                                [hiddenCloseButton]="true"
                            />
                        }

                        @if (flexibleUploadFiles.length) {
                            <tec-item-group style="width: 100%">
                                @for (file of flexibleUploadFiles; track file.name + $index; let i = $index) {
                                    <tec-item
                                        [tagImage]="{
                                            icon: file.name.toLowerCase().endsWith('.pdf') ? 'icon-pdf' : 'icon-image'
                                        }"
                                    >
                                        <tec-list-detail>
                                            <span [title]="file.name">{{ truncateFlexibleFileName(file.name) }}</span>
                                        </tec-list-detail>
                                        <tec-button-icon
                                            icon="icon-trash"
                                            (click)="removeFlexibleUploadFile(i)"
                                        />
                                    </tec-item>
                                }
                            </tec-item-group>
                        }
                        @if (canAddMoreFlexibleUploadFiles) {
                            <app-document-upload
                                method="manual"
                                [multiple]="true"
                                [acceptedFileTypes]="flexibleUploadAcceptedTypes"
                                [control]="flexibleUploadControl"
                                [browseButtonLabel]="'DOCUMENTS.EXPLORE' | translate"
                                [ariaLabel]="flexibleUploadTitleKey | translate"
                                (filesSelected)="onFlexibleFilesSelected($event)"
                            />
                        }

                        @if (flexibleUploadErrorKey) {
                            <tec-alert
                                style="width: 100%"
                                [msg]="flexibleUploadErrorKey | translate"
                                status="error"
                                (closeAlert)="flexibleUploadErrorKey = ''"
                            />
                        }
                    </tec-tile>
                </div>
            }

            <!-- MIDNI: cámara lee el QR generado por la app MiDNI (PC o móvil con otro teléfono mostrando el QR) -->
            @if (midniEnabled && midniScreen === 'desktop' && !handsetLandscape && !pageWarning.show) {
                <div class="midni-screen" [class.midni-screen--mobile-scan]="isMidniMobileScanContext">
                    @if (midniError) {
                        <tec-tile
                            type="status"
                            [title]="'OCR.MIDNI.ERROR_TITLE' | translate"
                            [subtitle]="midniError === 'error' ? ('OCR.MIDNI.ERROR_DESCRIPTION' | translate) : midniError"
                            icon="icon-alert">
                        </tec-tile>
                    } @else {
                        <div class="midni-screen__scan-wrap">
                            <app-midni-qr-scanner #midniScanner
                                [constraints]="ocrService.constraints"
                                [instructionI18nKey]="midniScannerInstructionI18nKey"
                                (qrDetected)="onMiDNIQrDetected($event)"
                                (promptRequest)="onMiDNIScanPrompt($event)"
                                (cameraPermissionRevoked)="onCameraPermissionRevoked()" />
                            <div class="tec-alert--float midni-screen__alert-float">
                                @if (!loading.show && !showCapturedImage && alertContent?.label && alertContent?.status) {
                                    <tec-alert
                                        hiddenCloseButton
                                        type="message"
                                        [status]="alertContent.status"
                                        [msg]="alertContent.label"
                                        [icon]="alertContent.icon"
                                    ></tec-alert>
                                }
                            </div>
                        </div>
                        <tec-link
                            class="midni-download-help-link"
                            [label]="'OCR.MIDNI.DOWNLOAD_HELP_LINK' | translate"
                            (click)="openMiDNIDownloadHelp()"
                        ></tec-link>
                    }
                </div>
            }

            <!-- EUDI Wallet (NIF-960): QR desktop / Abrir Wallet móvil — alineado Figma -->
            @if (eudiEnabled && eudiScreen === 'wallet' && !handsetLandscape && !pageWarning.show) {
                <div class="eudi-screen" [class.eudi-screen--mobile]="isEudiMobileContext">
                    @if (eudiError) {
                        <tec-tile
                            type="status"
                            [title]="'OCR.EUDI.ERROR_TITLE' | translate"
                            [subtitle]="eudiError === 'error' ? ('OCR.EUDI.ERROR_DESCRIPTION' | translate) : eudiError"
                            icon="icon-alert">
                        </tec-tile>
                    } @else if (isEudiMobileContext) {
                        <!-- Figma 9866:32750 — tec-tag-image sin status (border DS); items igual -->
                        <tec-tag-image
                            class="eudi-screen__brand-tag"
                            [img]="'assets/images/eudi-wallet.png'"
                            size="xl"
                        ></tec-tag-image>
                        <p class="eudi-screen__instruction">{{ 'OCR.EUDI.INSTRUCTION_MOBILE' | translate }}</p>
                        <tec-tile
                            type="default"
                            styling="default"
                            class="eudi-wallet-data-tile"
                            [title]="'OCR.EUDI.DATA_INCLUDE_TITLE' | translate"
                            [subtitle]="'OCR.EUDI.DATA_INCLUDE_SUBTITLE' | translate"
                        >
                            <div class="eudi-data-items">
                                <tec-item-group>
                                    @for (group of eudiDataGroups; track group.icon; let last = $last) {
                                        <tec-item
                                            [title]="group.titleKey | translate"
                                            [tagImage]="{ icon: group.icon }"
                                            outline
                                        >
                                            <tec-info-group>
                                                <span>{{ group.detailKey | translate }}</span>
                                            </tec-info-group>
                                        </tec-item>
                                        @if (!last) {
                                            <tec-divider />
                                        }
                                    }
                                </tec-item-group>
                            </div>
                        </tec-tile>
                    } @else {
                        <!-- Figma 9866:30478 — tile + grid/e2: QR+alert | tile datos -->
                        <p class="eudi-screen__instruction">{{ 'OCR.EUDI.INSTRUCTION_DESKTOP' | translate }}</p>
                        <tec-tile type="default" styling="default" class="eudi-wallet-outer">
                            <div class="grid grid-e2 eudi-wallet-grid">
                                <div class="eudi-wallet-qr-col">
                                    @if (eudiAuthorizationUri) {
                                        <tec-qr
                                            [url]="eudiAuthorizationUri"
                                            [showLinks]="false"
                                            [text]="'OCR.EUDI.QR_HINT' | translate"
                                        ></tec-qr>
                                    }
                                    <tec-alert
                                        [msg]="'OCR.EUDI.RETURN_ALERT' | translate"
                                        type="message"
                                        hiddenCloseButton
                                        icon="icon-info"
                                    ></tec-alert>
                                </div>
                                <tec-tile
                                    type="default"
                                    styling="default"
                                    [title]="'OCR.EUDI.DATA_INCLUDE_TITLE' | translate"
                                    [subtitle]="'OCR.EUDI.DATA_INCLUDE_SUBTITLE' | translate"
                                >
                                    <tec-item-group>
                                        @for (group of eudiDataGroups; track group.icon; let i = $index, last = $last) {
                                            <tec-item
                                                [title]="group.titleKey | translate"
                                                [tagImage]="{ icon: group.icon }"
                                                outline
                                            >
                                                <tec-info-group>
                                                    <span>{{ group.detailKey | translate }}</span>
                                                </tec-info-group>
                                            </tec-item>

                                            <!-- Si no es el último item, añadir un divider -->
                                            @if (!last) {
                                                <tec-divider />
                                            }
                                        }
                                    </tec-item-group>
                                </tec-tile>
                            </div>
                        </tec-tile>
                    }
                </div>
            }

            @if (eudiEnabled && eudiScreen === 'help' && !handsetLandscape && !pageWarning.show) {
                <!-- Figma 9859:17712 — header + layout/50-50 tiles; FAQ = collapse-item flat -->
                <div class="eudi-screen eudi-screen--help" [class.eudi-screen--mobile]="isEudiMobileContext">
                    <div class="eudi-screen__help-header">
                        <h2 class="eudi-screen__help-title">
                            {{ (isEudiMobileContext ? 'OCR.EUDI.HELP_TITLE_MOBILE' : 'OCR.EUDI.HELP_TITLE') | translate }}
                        </h2>
                        @if (!isEudiMobileContext) {
                            <p class="eudi-screen__help-subtitle">{{ 'OCR.EUDI.HELP_SUBTITLE' | translate }}</p>
                        }
                    </div>
                    <div
                        class="layout--50-50 eudi-help-grid"
                        [class.eudi-help-grid--stack]="isEudiMobileContext"
                    >
                        <tec-tile
                            type="default"
                            styling="default"
                            icon="icon-capture-popup"
                            [title]="'OCR.EUDI.HELP_INSTRUCTIONS_TITLE' | translate"
                        >
                            <div class="eudi-help-tile-body">
                                <ol class="eudi-help-steps">
                                    <li>{{ (isEudiMobileContext ? 'OCR.EUDI.HELP_STEP_1_MOBILE' : 'OCR.EUDI.HELP_STEP_1_DESKTOP') | translate }}</li>
                                    <li>{{ 'OCR.EUDI.HELP_STEP_2' | translate }}</li>
                                    <li>{{ (isEudiMobileContext ? 'OCR.EUDI.HELP_STEP_3_MOBILE' : 'OCR.EUDI.HELP_STEP_3_DESKTOP') | translate }}</li>
                                </ol>
                                <p class="eudi-help-download">{{ 'OCR.EUDI.HELP_DOWNLOAD_LABEL' | translate }}</p>
                                <div class="grid grid-e2-sm eudi-help-store-row">
                                    <tec-button-collapse
                                        [img]="'assets/images/icon-google-play.svg'"
                                        [title]="'OCR.EUDI.PLAY_STORE' | translate"
                                        [expanded]="false"
                                        (click)="openEudiPlayStore()">
                                    </tec-button-collapse>
                                    <tec-button-collapse
                                        [img]="'assets/images/icon-app-store' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                        [title]="'OCR.EUDI.APP_STORE' | translate"
                                        [expanded]="false"
                                        (click)="openEudiAppStore()">
                                    </tec-button-collapse>
                                </div>
                            </div>
                        </tec-tile>
                        <tec-tile
                            type="default"
                            styling="default"
                            icon="icon-help-circle"
                            [title]="'OCR.EUDI.HELP_FAQ_TITLE' | translate"
                        >
                            <div class="eudi-help-faq">
                                @for (item of eudiFaqItems; track item.id) {
                                    <button
                                        type="button"
                                        class="eudi-help-faq__item"
                                        [class.eudi-help-faq__item--open]="eudiHelpExpanded[item.id]"
                                        (click)="toggleEudiHelp(item.id)"
                                    >
                                        <span class="eudi-help-faq__q">{{ item.questionKey | translate }}</span>
                                        <tec-icon
                                            [name]="eudiHelpExpanded[item.id] ? 'icon-chevron-down' : 'icon-chevron-right'"
                                            size="xs"
                                        ></tec-icon>
                                        @if (eudiHelpExpanded[item.id]) {
                                            <p class="eudi-help-faq__a">{{ item.answerKey | translate }}</p>
                                        }
                                    </button>
                                }
                            </div>
                        </tec-tile>
                    </div>
                </div>
            }
        }
    </ng-container>

    <!-- ACCIONES -->
    <ng-container actions>
        <!-- SIN PERMISOS -->
        @if (!permissionsCamera) {
            <tec-button type="secondary" [size]="'lg'" (clickEvent)="isVisibleChangeDevice = true;">
                {{ 'GENERAL.BUTTON.OTHER_DEVICE' | translate }}
            </tec-button>
            <tec-button [size]="'lg'" (clickEvent)="checkPermissions()">
                {{ 'GENERAL.BUTTON.PERMISSIONS_ACTIVATED' | translate }}
            </tec-button>
        }

        <!-- CON PERMISOS -->
        @if (permissionsCamera) {
            <!-- MIDNI: VOLVER ATRÁS -->
            @if (midniEnabled && midniScreen !== null && !handsetLandscape && !loading.show && !pageWarning.show) {
                @if (!midniError) {
                    <tec-button
                        [label]="'OCR.MIDNI.GO_BACK' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="backFromMiDNI()"
                    ></tec-button>
                }
                @if (midniScreen === 'desktop' && midniError) {
                    <tec-button
                        [label]="'OCR.MIDNI.CHANGE_DEVICE' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="isVisibleChangeDevice = true"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.RETRY' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="retryMiDNI()"
                    ></tec-button>
                }
            }

            <!-- NIF-802 Flexible: acciones picker / upload -->
            @if (flexibleScreen === 'picker' && !handsetLandscape && !loading.show && !pageWarning.show) {
                <tec-button
                    [label]="'OCR.MIDNI.GO_BACK' | translate"
                    [type]="'secondary'"
                    [size]="'lg'"
                    (clickEvent)="backToAutomaticScan()"
                ></tec-button>
            }
            @if (flexibleScreen === 'upload' && !handsetLandscape && !loading.show && !pageWarning.show) {
                <tec-button
                    [label]="'OCR.FLEXIBLE.CHANGE_METHOD' | translate"
                    [type]="'secondary'"
                    [size]="'lg'"
                    (clickEvent)="backFromFlexibleUpload()"
                ></tec-button>
                <tec-button
                    [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                    [type]="'default'"
                    [size]="'lg'"
                    [disabled]="!flexibleUploadFiles.length"
                    (clickEvent)="submitFlexibleUpload()"
                ></tec-button>
            }

            <!-- EUDI: acciones. Flexible→«Cambiar de método»; ACTIVA→«Volver atrás»; Solo-EUDI: sin Volver. -->
            @if (eudiEnabled && eudiScreen !== null && !handsetLandscape && !loading.show && !pageWarning.show) {
                @if (eudiScreen === 'help') {
                    <tec-button
                        [label]="'OCR.EUDI.CHANGE_DEVICE' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="isVisibleChangeDevice = true"
                    ></tec-button>
                    <tec-button
                        [label]="'OCR.EUDI.GO_BACK' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="closeEudiHelp()"
                    ></tec-button>
                } @else if (!eudiError) {
                    @if (!isEudiOnlyMode) {
                        <tec-button
                            [label]="(isFlexibleMode ? 'OCR.FLEXIBLE.CHANGE_METHOD' : 'OCR.EUDI.GO_BACK') | translate"
                            [type]="'secondary'"
                            [size]="'lg'"
                            (clickEvent)="backFromEudi()"
                        ></tec-button>
                    }
                    @if (isEudiMobileContext && eudiAuthorizationUri) {
                        <tec-button
                            [label]="'OCR.EUDI.OPEN_WALLET' | translate"
                            [type]="'default'"
                            [size]="'lg'"
                            (clickEvent)="openEudiWalletApp()"
                        ></tec-button>
                    }
                } @else {
                    @if (!isEudiOnlyMode) {
                        <tec-button
                            [label]="(isFlexibleMode ? 'OCR.FLEXIBLE.CHANGE_METHOD' : 'OCR.EUDI.GO_BACK') | translate"
                            [type]="'secondary'"
                            [size]="'lg'"
                            (clickEvent)="backFromEudi()"
                        ></tec-button>
                    }
                    <tec-button
                        [label]="'OCR.EUDI.RETRY' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="retryEudi()"
                    ></tec-button>
                }
            }

            <!-- TUTORIAL -->
            @if (operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
                <tec-button
                    [label]="'GENERAL.BUTTON.IM_READY' | translate"
                    [type]="'default'"
                    [size]="'lg'"
                    [disabled]="!tutorialContinueEnabled"
                    (clickEvent)="finishTutorial()"
                ></tec-button>
            }

            <!-- HELP -->
            @if (pageWarning.show) {
                @if (
                    pageWarning.type === PAGE_WARNING.INSUFFICIENT_OCR_READ ||
                    pageWarning.type === PAGE_WARNING.DIFFERENT_DOCUMENTS ||
                    (pageWarning.type === PAGE_WARNING.MISSING_ADDRESS && !flexibleUploadSession)
                ) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="isVisibleChangeDevice = true"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.RETRY' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="retryAllProcess()"
                    ></tec-button>
                }
                @if (
                    pageWarning.type === PAGE_WARNING.FLEXIBLE_UPLOAD_MISSING_SIDE || 
                    pageWarning.type === PAGE_WARNING.BOTH_SIDES_IN_ONE_IMAGE
                ) {
                    <tec-button
                        [label]="'OCR.FLEXIBLE.CHANGE_METHOD' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="changeMethodFromFlexibleUploadMissingSide()"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.RETRY' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="retryAllProcess()"
                    ></tec-button>
                }
                @if (pageWarning.type === PAGE_WARNING.MISSING_ADDRESS && flexibleUploadSession) {
                    <tec-button
                        [label]="'OCR.FLEXIBLE.CHANGE_METHOD' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="changeMethodFromFlexibleUploadMissingSide()"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.RETRY' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="retryAllProcess()"
                    ></tec-button>
                }
                @if (pageWarning.type === PAGE_WARNING.MISSING_ADDRESS && flexibleUploadSession) {
                    <tec-button
                        [label]="'OCR.FLEXIBLE.CHANGE_METHOD' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="changeMethodFromFlexibleUploadMissingSide()"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.RETRY' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="retryAllProcess()"
                    ></tec-button>
                }
                @if (pageWarning.type === PAGE_WARNING.INCORRECT_DOCUMENT_SIDE) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.RETRY' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="retryAllProcess()"
                    ></tec-button>
                }
                @if (pageWarning.type === PAGE_WARNING.HELP) {
                    @if (!isVisibleHelpValidDocuments) {
                        <!-- DESDE tec-nav-help -->
                        @if (isHelpByNavHelp) {
                            <tec-button
                                [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                                [type]="'secondary'"
                                [size]="'lg'"
                                (clickEvent)="isVisibleChangeDevice = true"
                            ></tec-button>
                            <tec-button
                                [label]="'GENERAL.BUTTON.RETRY' | translate"
                                [type]="'default'"
                                [size]="'lg'"
                                (clickEvent)="retryAllProcess()"
                            ></tec-button>
                        }

                        <!-- DESDE SEGUNDO INTENTO -->
                        @if (!isHelpByNavHelp) {
                            <tec-button
                                [label]="'GENERAL.BUTTON.RETRY' | translate"
                                [type]="'secondary'"
                                [size]="'lg'"
                                (clickEvent)="retryAllProcess()"
                            ></tec-button>
                            <tec-button
                                [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                                [type]="'default'"
                                [size]="'lg'"
                                (clickEvent)="isVisibleChangeDevice = true"
                            ></tec-button>
                        }
                    }
                    @if (isVisibleHelpValidDocuments) {
                        @if (isMidniHelpContext && !isNotValidDocument) {
                            <tec-button
                                [label]="'OCR.MIDNI.CHANGE_DEVICE' | translate"
                                [type]="'secondary'"
                                [size]="'lg'"
                                (clickEvent)="isVisibleChangeDevice = true"
                            ></tec-button>
                            <tec-button
                                [label]="'OCR.MIDNI.GO_BACK' | translate"
                                [type]="'default'"
                                [size]="'lg'"
                                (clickEvent)="retryAllProcess()"
                            ></tec-button>
                        }
                        @if (!isMidniHelpContext && !isNotValidDocument) {
                            <tec-button
                                [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                                [type]="'default'"
                                [size]="'lg'"
                                (clickEvent)="retryAllProcess()"
                            ></tec-button>
                        }
                        @if (isNotValidDocument) {
                            <tec-button
                                [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                                [type]="'secondary'"
                                [size]="'lg'"
                                (clickEvent)="isVisibleChangeDevice = true"
                            ></tec-button>
                            <tec-button
                                [label]="'GENERAL.BUTTON.GO_BACK' | translate"
                                [type]="'default'"
                                [size]="'lg'"
                                (clickEvent)="retryAllProcess()"
                            ></tec-button>
                        }
                    }
                }
            }

            <!-- BARCODE: captura manual (la automática sigue en barcode-scan) -->
            @if (barcodeScanActive && !pageWarning.show && !handsetLandscape && !loading.show && !barcodeSending) {
                <tec-button-icon
                    [type]="'circle'"
                    [icon]="'icon-camera'"
                    [size]="'lg'"
                    (clickEvent)="onBarcodeManualCapture()"
                ></tec-button-icon>
            }

            <!-- TAKE PHOTO -->
            @if (!operation?.config?.tutorial && !pageWarning.show && !handsetLandscape && (isModeSemiManual || flexibleScreen === 'photo') && !sendingResult && midniScreen === null && eudiScreen === null && !barcodeScanActive && flexibleScreen !== 'picker' && flexibleScreen !== 'upload') {
                @if (!capturedImage) {
                    <tec-button-icon
                        [type]="'circle'"
                        [icon]="'icon-camera'"
                        [size]="'lg'"
                        (clickEvent)="takePhoto()"
                    ></tec-button-icon>
                }
                @if (capturedImage) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.REPEAT' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="repeatPhoto()"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.UPLOAD_PHOTO' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="savePhoto()"
                    ></tec-button>
                }
            }
        }

    </ng-container>

    <!-- NAV HELP -->
    @if (!operation?.config?.iframe && permissionsCamera && !pageWarning.show && !handsetLandscape && flexibleScreen !== 'picker' && flexibleScreen !== 'upload' && eudiScreen === null && !capturedImage) {
        <tec-nav-help
            [elements]="operation?.config?.tutorial ? navsHelpTutorial : navsHelp"
            (clickEvent)="navHelpChange($event)"
        ></tec-nav-help>
    }

    <!-- WATERMARK -->
    @if ((designService.configDesign$ | async)?.showWatermark && !operation?.config?.iframe) {
        <tec-watermark type="default" />
    }
</tec-pwcs-layout>

<app-modal-scan-qr
    [ngClass]="{'pwcs-style-old': operation.config?.iframe, 'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleScan"
    [url]="auth.getQRUrl()"
></app-modal-scan-qr>

<ng-template #ocrAllowedDocsCollapseGroup>
    <div class="collapse-group">
        @if (isEudiOnlyMode) {
            <ul>
                <li>{{ 'HOME.EUDI_ONLY_ITEM' | translate }}</li>
            </ul>
        } @else if (isSpanishCompany()) {
            <ng-container *ngTemplateOutlet="ocrAllowedDocsSpanishCompany"></ng-container>
        } @else {
            @if (operation.config?.allowed_docs?.dni) {
                <tec-collapse
                    [title]="getOcrAllowedDniLabel()"
                    [expanded]="true"
                    secondary>
                    @if (operation.config?.not_allowed_docs?.dni?.length) {
                        <span>
                            {{ 'OCR.GENERAL.DOCUMENT_ID_EXCLUDE_THIS_COUNTRIES' | translate }}
                            @for (country of operation.config?.not_allowed_docs?.dni; track country; let isLast = $last; let isFirst = $first) {
                                @if (!isLast && !isFirst) {, }
                                @if (operation.config?.not_allowed_docs?.dni?.length > 1 && isLast) {
                                    {{ 'GENERAL.AND' | translate }}
                                }
                                {{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
                            }
                        </span>
                    } @else {
                        @if (operation.config?.allowed_docs?.dni?.length === 0) {
                            {{ 'OCR.GENERAL.DOCUMENT_ID_ACCEPT_ALL_COUNTRIES' | translate }}
                        }
                        @if (operation.config?.allowed_docs?.dni?.length) {
                            {{ 'OCR.GENERAL.DOCUMENT_ID_ACCEPT_THIS_COUNTRIES' | translate }}
                            @for (country of operation.config?.allowed_docs?.dni; track country; let isLast = $last; let isFirst = $first) {
                                @if (!isLast && !isFirst) {, }
                                @if (operation.config?.allowed_docs?.dni?.length > 1 && isLast) {
                                    {{ 'GENERAL.AND' | translate }}
                                }
                                {{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
                            }
                        }
                    }
                </tec-collapse>
            }
            @if (operation.config?.allowed_docs?.nie) {
                <tec-collapse
                    [title]="'OCR.GENERAL.DOCUMENT_TYPE.NIE' | translate"
                    [secondary]="true"
                    [notExpandable]="true">
                </tec-collapse>
            }
            @if (operation.config?.allowed_docs?.passport) {
                <tec-collapse
                    [title]="'OCR.GENERAL.DOCUMENT_TYPE.PASSPORT' | translate"
                    secondary>
                    <ng-container *ngTemplateOutlet="ocrPassportAllowedDocsHelp"></ng-container>
                </tec-collapse>
            }
            @if (eudiEnabled) {
                <tec-collapse
                    [title]="'HOME.EUDI_ONLY_ITEM' | translate"
                    [secondary]="true"
                    [notExpandable]="true">
                </tec-collapse>
            }
        }
    </div>
</ng-template>

<ng-template #ocrPassportAllowedDocsHelp>
    @if (operation.config?.not_allowed_docs?.passport?.length) {
        <span>
            {{ 'OCR.GENERAL.PASSPORT_EXCLUDE_THIS_COUNTRIES' | translate }}
            @for (country of operation.config?.not_allowed_docs?.passport; track country; let isLast = $last; let isFirst = $first) {
                @if (!isLast && !isFirst) {, }
                @if (operation.config?.not_allowed_docs?.passport?.length > 1 && isLast) {
                    {{ 'GENERAL.AND' | translate }}
                }
                {{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
            }
        </span>
    } @else {
        @if (operation.config?.allowed_docs?.passport?.length === 0) {
            {{ 'OCR.GENERAL.PASSPORT_ACCEPT_ALL_COUNTRIES' | translate }}
        }
        @if (operation.config?.allowed_docs?.passport?.length) {
            {{ 'OCR.GENERAL.PASSPORT_ACCEPT_THIS_COUNTRIES' | translate }}
            @for (country of operation.config?.allowed_docs?.passport; track country; let isLast = $last; let isFirst = $first) {
                @if (!isLast && !isFirst) {, }
                @if (operation.config?.allowed_docs?.passport?.length > 1 && isLast) {
                    {{ 'GENERAL.AND' | translate }}
                }
                {{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
            }
        }
    }
</ng-template>

<ng-template #ocrAllowedDocsSpanishCompany>
    <div class="item-group">
    <p><strong>{{ 'HOME.WHAT_DOCUMENTS_TO_USE' | translate }}</strong></p>
    @if (isDniForOtherCountries() || isPassportForOtherCountries()) {
        <div>
        <p><strong>{{ 'HOME.DOCS_ISSUED_BY_OTHER_COUNTRIES' | translate }}</strong></p>
        @if (isDniForOtherCountries()) {
            <tec-collapse
                [title]="getOcrAllowedDniEuropeanLabel()"
                [expanded]="true"
                secondary>
                @if (operation.config?.not_allowed_docs?.dni?.length) {
                    <span>
                        {{ 'OCR.GENERAL.DOCUMENT_ID_EXCLUDE_THIS_COUNTRIES' | translate }}
                        @for (country of operation.config?.not_allowed_docs?.dni; track country; let isLast = $last; let isFirst = $first) {
                            @if (!isLast && !isFirst) {, }
                            @if (operation.config?.not_allowed_docs?.dni?.length > 1 && isLast) {
                                {{ 'GENERAL.AND' | translate }}
                            }
                            {{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
                        }
                    </span>
                } @else if (operation.config?.allowed_docs?.dni?.length) {
                    <span>
                        {{ 'OCR.GENERAL.DOCUMENT_ID_ACCEPT_THIS_COUNTRIES' | translate }}
                        @for (country of operation.config?.allowed_docs?.dni; track country; let isLast = $last; let isFirst = $first) {
                            @if (!isLast && !isFirst) {, }
                            @if (operation.config?.allowed_docs?.dni?.length > 1 && isLast) {
                                {{ 'GENERAL.AND' | translate }}
                            }
                            {{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
                        }
                    </span>
                } @else {
                    <span>{{ 'HOME.SPANISH_COMPANY_DNI_EUROPEAN_ACCEPT' | translate }}</span>
                }
            </tec-collapse>
        }
        @if (isPassportForOtherCountries()) {
            <tec-collapse
                [title]="'OCR.GENERAL.DOCUMENT_TYPE.PASSPORT' | translate"
                secondary>
                <ng-container *ngTemplateOutlet="ocrPassportAllowedDocsHelp"></ng-container>
            </tec-collapse>
        }
        </div>
    }
    @if (isDniForSpain() || isPassportForSpain()) {
        <div>
        <p><strong>{{ 'HOME.DOCS_ISSUED_BY_SPAIN' | translate }}</strong></p>
        @if (isDniForSpain()) {
            <tec-collapse
                [title]="getOcrAllowedDniSpainLabel()"
                [expanded]="true"
                secondary>
                <span>
                    {{ 'OCR.GENERAL.DOCUMENT_ID_ACCEPT_THIS_COUNTRIES' | translate }}
                    {{ 'COUNTRIES.ESP' | translate }}
                </span>
            </tec-collapse>
        }
        @if (isPassportForSpain()) {
            <tec-collapse
                [title]="'OCR.GENERAL.DOCUMENT_TYPE.PASSPORT' | translate"
                secondary>
                <ng-container *ngTemplateOutlet="ocrPassportAllowedDocsHelp"></ng-container>
            </tec-collapse>
        }
        </div>
    }
    </div>
    @if (operation.config?.allowed_docs?.nie) {
        <tec-collapse
            [title]="'OCR.GENERAL.DOCUMENT_TYPE.NIE' | translate"
            [secondary]="true"
            [notExpandable]="true">
        </tec-collapse>
    }
    @if (eudiEnabled) {
        <tec-collapse
            [title]="'HOME.EUDI_ONLY_ITEM' | translate"
            [secondary]="true"
            [notExpandable]="true">
        </tec-collapse>
    }
</ng-template>

<app-modal-instructions
    [ngClass]="{ dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleFlexibleUploadInstructions"
    [doc]="flexibleUploadInstructionsDoc"
></app-modal-instructions>

<app-modal-help-no-camera-permissions
    [ngClass]="{'pwcs-style-old': operation.config?.iframe, 'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleHelpNoPermissionsCamera"
    [url]="auth.getQRUrl()"
></app-modal-help-no-camera-permissions>

<app-modal-change-device
    [ngClass]="{'pwcs-style-old': operation.config?.iframe, 'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleChangeDevice"
    [url]="auth.getQRUrl()"
></app-modal-change-device>